import React, { createContext, useContext, useCallback } from 'react';
import staticProducts from '../data/products.json';

const ProductsContext = createContext(null);

export function ProductsProvider({ children }) {
  const products = staticProducts;

  const findBySlug = useCallback((slug) => products.find((p) => p.slug === slug), [products]);
  const findById = useCallback((id) => products.find((p) => p.id === id), [products]);

  return (
    <ProductsContext.Provider value={{ products, loading: false, error: false, refresh: () => {}, findBySlug, findById }}>
      {children}
    </ProductsContext.Provider>
  );
}

export function useProducts() {
  return useContext(ProductsContext);
}
